import React from "react";
import "./NFTCertificate.scss";

const NFTCertificate = ({ image, data = {} }) => {
  return (
    <div className="nft-certificate">
      <div className="certificate2-image-wrapper">
        <img src={image} alt="artwork" />
      </div>

      <div className="certificate2-info-card">
        <div className="certificate2-info-grid">
          <div className="certificate2-item">
            <p className="label">Name</p>
            <p className="value">{data.name}</p>
          </div>

          <div className="certificate2-item">
            <p className="label">Year</p>
            <p className="value">{data.year}</p>
          </div>

          <div className="certificate2-item">
            <p className="label">Size</p>
            <p className="value">{data.size}</p>
          </div>

          <div className="certificate2-item">
            <p className="label">Description</p>
            <p className="value certificate2-description">{data.description}</p>
          </div>
        </div>
        {data.attributes?.length > 0 && (
          <>
            <hr />
            <p className="label">Additional metadata</p>
            <div className="certificate2-info-grid">
              {data.attributes.map((attribute, index) => (
                <div
                  className="certificate2-item"
                  key={`${attribute.trait_type}-${index}`}
                >
                  <p className="label">{attribute.trait_type}</p>
                  <p className="value">{attribute.value}</p>
                </div>
              ))}
            </div>
          </>
        )}
        <hr />
        <div className="certificate2-info-grid certificate2-bottom">
          <div className="certificate2-item">
            <p className="label">Contract Issue Address</p>
            <p className="value">{data.issueAddress}</p>
          </div>

          <div className="certificate2-item">
            <p className="label">Contract Owner Address</p>
            <p className="value">{data.ownerAddress}</p>
          </div>

          <div className="certificate2-item">
            <p className="label">Token ID</p>
            <p className="value">{data.tokenId}</p>
          </div>

          <div className="certificate2-item">
            <p className="label">Token Type</p>
            <p className="value">{data.tokenType}</p>
          </div>

          <div className="certificate2-item">
            <p className="label">Token Supply</p>
            <p className="value">{data.tokenSupply}</p>
          </div>
        </div>
      </div>
      <p className="certificate-footer">powered by funooni</p>
    </div>
  );
};

export default NFTCertificate;
